import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianCurrency',
  standalone: true
})
export class IndianCurrencyPipe implements PipeTransform {

  transform(value: number | string): string {
    if (!value || value === 0) {
      return '';
    }

    const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    
    if (isNaN(numValue)) {
      return '';
    }

    // Format with Indian comma system
    const formattedNumber = this.formatIndianNumber(numValue);
    
    // Return with INR symbol
    return `₹${formattedNumber}`;
  }

  private formatIndianNumber(amount: number): string {
    const integerPart = Math.floor(Math.abs(amount));
    const decimalPart = amount % 1;
    const hasDecimal = decimalPart !== 0 && !Number.isInteger(amount);

    const intStr = integerPart.toString();
    const len = intStr.length;

    if (len <= 3) {
      return hasDecimal ? `${intStr}.${this.formatDecimalPart(amount)}` : intStr;
    }

    let result = '';
    let count = 0;

    // Process integer part from right to left (no decimal in this loop)
    for (let i = len - 1; i >= 0; i--) {
      result = intStr[i] + result;
      count++;

      // Add comma after first 3 digits from right
      if (count === 3 && i > 0) {
        result = ',' + result;
      }
      // Add comma after every 2 digits after the first 3
      else if (count > 3 && (count - 3) % 2 === 0 && i > 0) {
        result = ',' + result;
      }
    }

    if (hasDecimal) {
      result += '.' + this.formatDecimalPart(amount);
    }
    return result;
  }

  /** Format decimal part (e.g. 0.35 -> "35", max 2 digits for currency). */
  private formatDecimalPart(amount: number): string {
    const decimal = Math.abs(amount) % 1;
    const rounded = Math.round(decimal * 100) / 100;
    const str = rounded.toFixed(2);
    return str.slice(2); // "0.35" -> "35"
  }
}
